import { AppStateModel, StoreSelectors } from '@store/app.reducer';
import { createSelector } from '@ngrx/store';
import { getIdTitleEngItem } from '@core/helpers';

export const selectDeviceModelsFeature = (state: AppStateModel) => state[StoreSelectors.DeviceModels];

export const selectDeviceModelsFullState = createSelector(selectDeviceModelsFeature, (state) => state);
export const selectCompanyMeteringDeviceModels = createSelector(selectDeviceModelsFeature, (state) => state.companyMeteringDevicesModels);
export const selectCompanyMeteringDeviceModelsArray = createSelector(selectDeviceModelsFeature, (state) => state.companyMeteringDevices);
export const selectMeteringDeviceModels = createSelector(selectDeviceModelsFeature, (state) => state.meteringDevicesModels);
export const selectMeteringDeviceModelsArray = createSelector(selectDeviceModelsFeature, (state) => state.meteringDevices);
export const selectMeteringDeviceModelById = (id: any) => createSelector(selectMeteringDeviceModels, (models) => models?.[id]);
export const selectMeteringDeviceModelsForSelectors = createSelector(selectMeteringDeviceModelsArray, (models) =>
    models.map((w) => getIdTitleEngItem(w))
);
export const selectGatewayModels = createSelector(selectDeviceModelsFeature, (state) => state.gatewayModels);
export const selectGatewayModelsArray = createSelector(selectDeviceModelsFeature, (state) => state.gateways);
export const selectGatewayModelsById = (id: any) => createSelector(selectGatewayModels, (models) => models?.[id]);
export const selectGatewayModelsForSelectors = createSelector(selectGatewayModelsArray, (models) =>
    models.map((w) => getIdTitleEngItem(w))
);
export const selectBaseStationModels = createSelector(selectDeviceModelsFeature, (state) => state.baseStationModels);
export const selectBaseStationModelsArray = createSelector(selectDeviceModelsFeature, (state) => state.baseStations);
export const selectBaseStationModelById = (id: any) => createSelector(selectBaseStationModels, (models) => models?.[id]);
export const selectBaseStationModelsForSelectors = createSelector(selectBaseStationModelsArray, (models) =>
    models.map((w) => getIdTitleEngItem(w))
);
